import { translate } from '../../../utils/translation'

export const useBalanceTranslation = () => ({
  balance: translate('Saldo'),
  cashbackBalance: translate('Saldo em cashback'),
  pointsBalance: translate('Saldo em pontos'),
})
